import React from "react";
import { OrgHomeCompactStack } from "./OrgHomeNavigation";

import { useIntlTokens } from "../../components/mobile/useIntlTokens";

import { OrgStoresCompactScreen } from "./OrgStores/OrgCompactStores";

export function OrgHomeCompact() {
  const intl_tokens = useIntlTokens();

  return (
    <OrgHomeCompactStack.Navigator>
      <OrgHomeCompactStack.Screen
        name="OrgStores"
        component={OrgStoresCompactScreen}
        options={{
          title: intl_tokens.Units,
          headerShown: false,
        }}
      />
    </OrgHomeCompactStack.Navigator>
  );
}
